
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {refCount, publishReplay, catchError} from 'rxjs/operators';
import { Injectable, EventEmitter, Output, Inject, OnDestroy} from '@angular/core'
// import { Http, Headers, Response} from '@angular/http'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'

import { AuthService } from './auth.service'
import {SharedMethodsModule} from '../insa-custom-scripts/sharedMethods';
import { RiskProfileNotifications,
         Language,
         RiskProfileDataModel,
         RiskProfileModel,
         RiskProfileQuestionsModel,
         RiskProfileAssessmentModel,
         RiskAssesmentDataModel } from '../insa-models/riskProfileAssessment.model'
import { appStateProvider } from '../insa-providers/AppStateProvider'
import { appConfig } from '../../insaweb.config'
import { LocalizeService } from './localize.service';

@Injectable()
export class RiskAssessmentService implements OnDestroy{

    private language = 'en';
    private hostAddress = appConfig.insaServiceAddress;
    private servicesURL = "/RiskAssessment";

    riskProfileReport: string = undefined;
    authServiceSubscription;
    stateSubscription;

    @Output() RiskProfileNotificationsEvent: EventEmitter<RiskProfileNotifications> = new EventEmitter<RiskProfileNotifications>(true);
    @Output() RiskProfilesEvent: EventEmitter<RiskProfileModel[]> = new EventEmitter<RiskProfileModel[]>(true);
    @Output() RiskProfileAssessmentQuestionsEvent: EventEmitter<RiskProfileQuestionsModel[]> = new EventEmitter<RiskProfileQuestionsModel[]>(true);
    @Output() getRiskProfilePdfEvent: EventEmitter<string> = new EventEmitter<string>(true);

    constructor(private _appStateProvider: appStateProvider, private http: HttpClient, private _authService: AuthService, private _localize: LocalizeService) {
        this.language = this._localize.getLocale().substring(0, 2);
        this.stateSubscription = _appStateProvider.subscribe(eventdata => this.initDataFetching(eventdata));
        this.authServiceSubscription = this._authService.LoggedInStatusChangedEmitter.subscribe((loggedIn) => {
            if(loggedIn.value === false){
                this.language = this._localize.getLocale().substring(0, 2);
            }
  
        });
    }


    
    initDataFetching(e) {
        this.language = this._localize.getLocale().substring(0, 2);

        if (appConfig.menuShowRiskProfile) {
            this.getRiskProfileNotifications();
        }
    }

    getRiskProfileNotifications() {
        let partnerValue = this._appStateProvider.selectedPartner.value;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        return this.http.get(
            `${this.hostAddress}${this.servicesURL}/RiskProfileNotifications?partnerValue=${partnerValue}&SessionID=${this._authService.sessionId}?tsp=${timeStamp}`,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error getting risk profile notification")))
            //.map(res => res.json())
            .toPromise()
            .then((data: RiskProfileNotifications) => { //holi
                // console.log(data);
                this._appStateProvider.riskProfileNotifications = data;
                this.RiskProfileNotificationsEvent.emit(data);
                return data;
            });
    }

    getRiskAssessmentQuestions(riskProfileId: number, riskProfileAssesmentId: number = null) {
        this._appStateProvider.fetchingRiskProfiles = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let includeResultsId = riskProfileAssesmentId ? `&riskProfileAssesmentId=${riskProfileAssesmentId}` : '';
        let timeStamp = +new Date();

        return this.http.get(
            `${this.hostAddress}${this.servicesURL}/RiskProfileQuestions?SessionID=${this._authService.sessionId}&riskProfileId=${riskProfileId}${includeResultsId}?tsp=${timeStamp}`,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error getting risk assessment questions")))
            //.map(res => res.json())
            .toPromise()
            .then((data: RiskProfileQuestionsModel[]) => { //holi
                this.RiskProfileAssessmentQuestionsEvent.emit(data);
                this._appStateProvider.fetchingRiskProfiles = false;
                return data
            });
    }


    getRiskProfiles() {
        this._appStateProvider.fetchingRiskProfiles = true;
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();
      
        this.http.get(
            `${this.hostAddress}${this.servicesURL}/RiskProfiles?partnerIndex=${this._appStateProvider.selectedPartner.value}&SessionID=${this._authService.sessionId}?tsp=${timeStamp}`,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error while getting risk profile")))
            //.map(res => res.json())
            .subscribe((data: RiskProfileModel[]) => {
                if (data === null || data === undefined) {
                    data = [];
                }
                data.forEach(rp => {
                    rp.Assessments.sort((a, b) => (a.CreateDate < b.CreateDate) ? 1 : 0);
                });
                this.RiskProfilesEvent.emit(data);
                this._appStateProvider.fetchingRiskProfiles = false;
            });
    }

    addRiskAssessment(riskAssessmentData: RiskAssesmentDataModel) {
        let headers = this._authService.getAuthHeaders('application/json');

        let body = JSON.stringify(riskAssessmentData);
        const url = this.hostAddress + this.servicesURL + '/RiskProfileAssessments';
        return this.http.post(url, body, { headers }).toPromise().catch(err => {
            console.log(err);
            this.handleError(err, "Error adding risk assessment");
        })
    }

    updateRiskAssessment(riskAssessmentData: RiskAssesmentDataModel) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(riskAssessmentData);
        const url = this.hostAddress + this.servicesURL +'/RiskProfileAssessments';
        return this.http.put(url, body, { headers }).toPromise().catch(err => {
            console.log(err);
            this.handleError(err, "Errror updating risk assessment");
        })
    }

    deleteRiskAssessment(riskProfileAssessmentId: number) {
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.delete(`${this.hostAddress}${this.servicesURL}/RiskProfileAssessments?riskProfileAssessmentId=${riskProfileAssessmentId}`, {headers}).toPromise().catch(err => {
            this.handleError(err, "Error deleting risk assessment")
        })
    }

    updateRiskProfile(riskProfileData: RiskProfileDataModel) {
        let headers = this._authService.getAuthHeaders('application/json');
        let body = JSON.stringify(riskProfileData);
        const url = this.hostAddress + this.servicesURL +'/RiskProfiles';
        return this.http.put(url, body, { headers }).toPromise().catch(err => {
            console.log(err);
            this.handleError(err, "Error during updating risk profile");
        })
    }

    createRiskProfile(riskProfile: RiskProfileModel) {
        let headers = this._authService.getAuthHeaders('application/json');
        const url = this.hostAddress + this.servicesURL + '/RiskProfiles';
        let body = JSON.stringify(riskProfile);
        return this.http.post(url, body, { headers }).toPromise().catch(err => {
            console.log(err);
            this.handleError(err, "Error during creating risk profile");
        })
    }

    deleteRiskProfile(riskProfileId: number) {
        let headers = this._authService.getAuthHeaders('application/json');
        return this.http.delete(`${this.hostAddress}${this.servicesURL}/RiskProfiles?riskProfileId=${riskProfileId}`, {headers}).toPromise().catch(err => {
            console.log(err);
            this.handleError(err, "Error deletinf risk profile id " + riskProfileId);
        })
    }

    getRiskProfilePDF(riskProfileId: number = undefined, riskProfileAssessmentId: number = undefined, languageId: number = 1) {
        let headers = this._authService.getAuthHeaders('application/json');
        let timeStamp = +new Date();

        this._appStateProvider.fetchingPDF = true;
        // if riskProfileId is defined, we show empty report, otherwise the one with answers
        let reportType = riskProfileAssessmentId ? 'answers' : 'empty';
        let urlParam1 = riskProfileId ? `&riskProfileId=${riskProfileId}` : ''
        let urlParam2 = riskProfileAssessmentId ? `&riskProfileAssessmentId=${riskProfileAssessmentId}` : '';
        let req = this.http.get(
            `${this.hostAddress}${this.servicesURL}/GetRiskProfilePDF?reportType=${reportType}${urlParam1}${urlParam2}&sessionID=${this._authService.sessionId}&languageId=${languageId}?tsp=${timeStamp}`,
            { headers })
            .pipe(
                publishReplay(),
                refCount(),
                catchError(err => this.handleError(err, "Error loading risk profile report")))
            //holi
            // .map((res) => { 
            //     return res.json();
            // });

        req.subscribe((data:string) => { //holi
            if (data === null) {
                this.riskProfileReport = "";
            } else {
                this.riskProfileReport = data;
            }
            this.getRiskProfilePdfEvent.emit(this.riskProfileReport);
            this._appStateProvider.fetchingPDF = false;
        }, error => {
            this.handleError;
            this.getRiskProfilePdfEvent.emit('ERROR');
        })

    };



    private handleError(error: any, message: string) {
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
            SharedMethodsModule.addNotification("#notification", message, false);  
        return observableThrowError(errMsg);
    }

    ngOnDestroy() {
        this.stateSubscription.unsubscribe();
        this.authServiceSubscription.unsubscribe();
    }



}


// WEBPACK FOOTER //
// ./app/insa-services/risk-assessment.service.ts